import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function LastSeisure({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriLastSeisure: answers.xcopriLastSeisure }}
          onSubmit={(newAnswers) => onSubmit({ ...answers, xcopriLastSeisure: newAnswers.xcopriLastSeisure })}
          onBack={onBack}
          title={`Can you share when the most recent seizure occurred for you (or the patient)?`}
          keyForAnswer={`xcopriLastSeisure`}
          choices={[
            'Within the last week',
            'Within the last month',
            'Within the last 6 months',
            'Between 7 and 12 months ago',
            'Over 1 year ago',
          ]}
          selectOne
          showOther={false}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
